import { render, staticRenderFns } from "./balanceDtl.vue?vue&type=template&id=2fb49928&scoped=true&"
import script from "./balanceDtl.vue?vue&type=script&lang=js&"
export * from "./balanceDtl.vue?vue&type=script&lang=js&"
import style0 from "./balanceDtl.vue?vue&type=style&index=0&id=2fb49928&prod&scoped=true&lang=css&"
import style1 from "./balanceDtl.vue?vue&type=style&index=1&id=2fb49928&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb49928",
  null
  
)

export default component.exports